import * as React from "react";

const ChevronRightIcon = ({ color = "#D0D5DD", ...props }: React.SVGProps<SVGSVGElement> & { color?: string }) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 12L10 8L6 4" stroke="#D0D5DD" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default ChevronRightIcon;